import type { CategoryInfo } from "@/types/media";

export const categories: CategoryInfo[] = [
  {
    key: "movie",
    type: "movie",
    name: "电影",
    icon: "ri-film-line",
    description: "汇集院线新片与经典佳作，涵盖科幻、剧情、动作、动画等多元类型，总有一部适合你。",
    count: 9,
  },
  {
    key: "tv",
    type: "tv",
    name: "电视剧",
    icon: "ri-live-line",
    description: "热播剧集与口碑佳作实时更新，古装、悬疑、都市、青春一网打尽，追剧不迷路。",
    count: 10,
  },
  {
    key: "variety",
    type: "variety",
    name: "综艺",
    icon: "ri-mic-line",
    description: "竞技、真人秀、美食、访谈等热门综艺内容，轻松解压，下饭首选。",
    count: 3,
  },
];

export const regionOptions = ["全部", "国产", "欧美", "日韩"];
export const yearOptions = ["全部", "2024", "2023", "2022"];
export const genreOptions = [
  "全部",
  "科幻",
  "悬疑",
  "爱情",
  "古装",
  "犯罪",
  "剧情",
  "冒险",
  "综艺",
  "治愈",
];
export const sortOptions = ["最新", "最热", "评分"];